<template>
  <Tab @close="removeCurrent">
    <template #container>
      <div>
        <v-row>
          <v-col cols="8">
            <Editor :selected="selected" @reload="$refs.treeview.fetchDocumentations()"></Editor>
          </v-col>
          <v-col cols="4">
            <Treeview ref="treeview" v-model="selected"></Treeview>
          </v-col>
        </v-row>
      </div>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import Treeview from "./Treeview"
import Editor from "./Editor"

export default {
  name: "Documentation",
  components: {
    Treeview,
    Editor,
  },
  mixins: [tab],
  data: () => ({
    selected: null,
  }),
}
</script>
